// extracted by mini-css-extract-plugin
export default {"addNewNote":"c5wpGMSROwFahP9obWtT","notesTable":"FExqDNS4rF_gkqDf_Y2f"};